export const ItemTypes = [
  'background_identification',
  'immigration',
  'license',
  'certification',
  'assessment',
  'health_document',
  'other_document',
];

export const ItemTypeTitles = {
  background_identification: 'Background and Identification',
  immigration: 'Immigration',
  license: 'License',
  certification: 'Certification',
  assessment: 'Assessment',
  health_document: 'Health Document',
  other_document: 'Other Document',
};
